module.exports = __webpack_public_path__ + "img/farming_8.d26b66da.png";